<div
  class="bottom-menu-modal"
  #modal
  [ngStyle]="{
    marginTop: marginTop + 'px',
  }"
>
  <button class="close-btn" (click)="closed.emit()" *ngIf="showCloseButton">
    <i class="material-icons">cancel</i>
  </button>
  <div class="drag-wrapper d-block d-lg-none" #dragPointer></div>
  <div
    class="bottom-menu-modal-body"
    [ngStyle]="{
    height: 'calc(100dvh - ' + (marginTop + translateY) + 'px)',
    overflowY: !draggable || translateY === 0 ? 'auto' : 'hidden',
  }"
  >
    <ng-template #container></ng-template>
  </div>
</div>

<div class="bottom-modal-overlay" #overlay></div>
